import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import './LegalFooter.css';

const LegalFooter = () => {
  const location = useLocation();

  // Hide footer on login/signup/auth screens and showcase pages
  const hiddenPaths = ['/login', '/signup', '/forgot-password', '/reset-password', '/change-password'];
  const isShowcase = location.pathname.startsWith('/collection/');
  if (hiddenPaths.includes(location.pathname) || isShowcase) {
    return null;
  }

  return (
    <footer className="legal-footer">
      <div className="legal-footer-content">
        <span className="legal-footer-copy">&copy; {new Date().getFullYear()} QorVertex LLC</span>
        <span className="legal-footer-sep">&middot;</span>
        <Link to="/terms">Terms of Service</Link>
        <span className="legal-footer-sep">&middot;</span>
        <Link to="/privacy">Privacy Policy</Link>
        <span className="legal-footer-sep">&middot;</span>
        <Link to="/dmca">DMCA</Link>
        <span className="legal-footer-sep">&middot;</span>
        <Link to="/contact">Contact</Link>
      </div>
    </footer>
  );
};

export default LegalFooter;
